<template>
  <div id="app">
    <template v-if="isIE">
      <error-page code="not_compatible" />
    </template>
    <template v-else>
      <service-worker-notification v-if="false" is-absolute />
      <custom-notification :duration="3000" />
      <loader-text
        v-if="_.isNull($route.name)"
        :title="$t('loading')"
      />
      <template v-else>
        <vue-fullscreen ref="fullscreen" background="#FFF">
          <div v-blur="blurConfig" class="h-100-vh">
            <main class="h-100-vh">
              <router-view :key="$route.fullPath" />
            </main>
          </div>
        </vue-fullscreen>
      </template>
    </template>
  </div>
</template>


<script>
  import ErrorPage from '@/views/Error';
  import VueFullscreen from 'vue-fullscreen/src/component';
  import ServiceWorkerNotification from '@triotech/vue-core/src/components/ServiceWorkerNotification';
  import CustomNotification from '@triotech/vue-core/src/components/CustomNotification';
  import LoaderText from '@/components/loader-text';

  export default {
    name: 'App',
    components: {
      ErrorPage,
      VueFullscreen,
      ServiceWorkerNotification,
      CustomNotification,
      LoaderText,
    },
    data() {
      return {
        isFullScreen: false,
        blurConfig: {
          isBlurred: false,
          opacity: 0.4,
          filter: 'blur(5px)',
          transition: 'all .1s linear',
        },
      };
    },
    computed: {
      isBlurred() {
        return this.blurConfig.isBlurred;
      },
      isOnTest() {
        return this.$route.name === 'test';
      },
      isIE() {
        return navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/));
      },
    },
    created() {
      this.$i18n.fallbackLocale = 'fr';
      if (this.user()) {
        if(this.user().preferred_locale == undefined)
        {
          this.$helper.setLocale('FR_fr');
        }
        else{
          this.$helper.setLocale(this.user().preferred_locale);
        }
      }
      else{
        this.$helper.setLocale(this.$i18n.fallbackLocale);
      }
    },
    mounted() {
      window.addEventListener('focus', this.setBlur);
      window.addEventListener('blur', this.setBlur);
    },
    methods: {
      setFullScreen() {
        this.$refs.fullscreen.toggle();
      },
      setBlur(event) {
        const isBlurred = event.type === 'blur';
        if (this.isOnTest || this.isBlurred) {
          this.blurConfig = Object.assign({}, this.blurConfig, {
            isBlurred,
          });
        }
      },
    },
  };
</script>

<style lang="scss">
  @import '~@/scss/frontend';
</style>
